import { ActivatedRouteSnapshot, Router } from '@angular/router';
import { RadioState } from '@app/core/states/radio.state';
import { Store } from '@ngxs/store';
import { combineLatest, Observable } from 'rxjs';
import { filter, map, mergeMap, startWith } from 'rxjs/operators';

export interface DataWithId {
  id: number;
}

type DataId = any & DataWithId;

export interface DataResolved<T extends DataId> {
  data$: Observable<T>;
}

export abstract class GenericResolverResolver<T extends DataId> {
  constructor(
    private readonly router: Router,
    private readonly store: Store,
    private readonly keyRoute: string,
    private readonly sourceObservable$: Observable<boolean>,
    private readonly dataSelector: (data: any) => T[],
  ) {}

  resolve(route: ActivatedRouteSnapshot): DataResolved<T> {
    const dataUrl = +route.paramMap.get(this.keyRoute);

    const currentData$ = this.sourceObservable$.pipe(
      startWith(false),
      filter(val => val),
      mergeMap<any, Observable<[T[], number]>>(() =>
        combineLatest([
          this.store.select(this.dataSelector),
          this.store.select<number>(RadioState.currentRadioId),
        ]),
      ),
      map(([data, currentRadioId]) => {
        const dataFound = data.find(obj => obj['id'] === dataUrl);

        if (!dataFound) {
          this.redirectTo(this.getUrl(currentRadioId));
        }

        return dataFound;
      }),
    );

    return {
      data$: currentData$,
    };
  }

  redirectTo(input: any[]) {
    this.router.navigate(input);
  }

  public abstract getUrl(currentRadioId: number): any[];
}
